import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/system/Login.vue'
import Layout from '../layout/MainLayout.vue'
import Home from '../views/system/Home.vue'
import User from '../views/system/User.vue'
import Role from '../views/system/Role.vue'
import Menu from '../views/system/Menu.vue'
import OperationLog from '../views/system/OperationLog.vue'
import RedisManage from '../views/system/RedisManage.vue'
import MallCategory from '../views/mall/Category.vue'
import MallGoods from '../views/mall/Goods.vue'
import MallStockWarnEmail from '../views/mall/StockWarnEmail.vue'
import MallVirtualCodePool from '../views/mall/VirtualCodePool.vue'
import MallImageResource from '../views/mall/ImageResource.vue'
import MallCarousel from '../views/mall/Carousel.vue'
import MallBanner from '../views/mall/Banner.vue'
import MallHotRecommend from '../views/mall/HotRecommend.vue'
import MallHomeModuleConfig from '../views/mall/HomeModuleConfig.vue'
import MallCustomerService from '../views/mall/CustomerService.vue'
import MallOrder from '../views/mall/Order.vue'
import MallOrderScrap from '../views/mall/OrderScrap.vue'
import MallPointDetail from '../views/mall/PointDetail.vue'
import MallPointTask from '../views/mall/PointTask.vue'
import MallMemberLevel from '../views/mall/MemberLevel.vue'
import MallMemberUser from '../views/mall/MemberUser.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login, meta: { title: '登录' } },
    {
      path: '/',
      component: Layout,
      children: [
        { path: 'home', component: Home, meta: { title: '首页' } },
        { path: 'system/user', component: User, meta: { title: '用户管理' } },
        { path: 'system/role', component: Role, meta: { title: '角色管理' } },
        { path: 'system/menu', component: Menu, meta: { title: '菜单管理' } },
        { path: 'system/operation-log', component: OperationLog, meta: { title: '操作日志' } },
        { path: 'system/redis', component: RedisManage, meta: { title: 'Redis管理' } },
        { path: 'mall/category', component: MallCategory, meta: { title: '商品分类信息' } },
        { path: 'mall/goods', component: MallGoods, meta: { title: '商品信息' } },
        { path: 'mall/stock-warn-email', component: MallStockWarnEmail, meta: { title: '预警邮件管理' } },
        { path: 'mall/virtual-code', component: MallVirtualCodePool, meta: { title: '虚拟商品码池' } },
        { path: 'mall/image-resource', component: MallImageResource, meta: { title: '图片信息' } },
        { path: 'mall/carousel', component: MallCarousel, meta: { title: '首页轮播图信息' } },
        { path: 'mall/banner', component: MallBanner, meta: { title: '首页横幅信息' } },
        { path: 'mall/hot-recommend', component: MallHotRecommend, meta: { title: '热门推荐信息' } },
        { path: 'mall/home-module', component: MallHomeModuleConfig, meta: { title: '模块配置' } },
        { path: 'mall/customer-service', component: MallCustomerService, meta: { title: '客服信息' } },
        { path: 'mall/member-level', component: MallMemberLevel, meta: { title: '会员等级管理' } },
        { path: 'mall/member-user', component: MallMemberUser, meta: { title: '会员信息' } },
        { path: 'mall/order', component: MallOrder, meta: { title: '订单信息' } },
        { path: 'mall/order-scrap', component: MallOrderScrap, meta: { title: '报废管理' } },
        { path: 'mall/point-detail', component: MallPointDetail, meta: { title: '积分明细信息' } },
        { path: 'mall/point-task', component: MallPointTask, meta: { title: '积分任务' } }
      ]
    }
  ]
})
